var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-root",attrs:{"id":"app"}},[_c('div',{staticClass:"app-content"},[_c('router-view')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer"},[_c('span',[_vm._v("Copyright © 深圳男科实验质评中心 ")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("粤ICP备14019749号")])])
}]

export { render, staticRenderFns }